import React from 'react';
// import { Button } from 'antd';
import DiagramUtils from '../../utils/DiagramUtils';
import DiagramsContainer from '../../containers/DiagramsContainer';
import DiagramUI from "../DiagramUI";
import Model from "./GroupModel";

export default class UI extends DiagramUI {

    state = {};

    constructor(props, context) {
        super(props, context);
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        if ((name === "layoutOrientation" ||
            name === "flexWrap" ||
            name === "alignItems" ||
            name === "justifyContent"
        ) && this.containerRef)
            this.containerRef.forceUpdate();
    }

    render() {

        return (
            <div className={"diagram-ui " + (this.props.className || "")} style={this.props.model.toStyle()}>
                <DiagramsContainer ref={ref => this.containerRef = ref}
                    diagrams={this.props.model.diagrams}
                    designer={this.props.model._sys.designer}
                    parent={this.props.model}
                    flag={this.props.model.flag} />
            </div>
        );
    }
}

// const type = new Model().getType();
// DiagramUtils.register(type, {
//     model: Model,
//     name: type,
//     enabled: true,
//     alias: "容器",
//     catalog: "布局与模板",
//     catalogIndex: -100,
//     svg: "#anticon-MasterLayout",
//     uiGetter: (model) => <UI model={model} />
// });